import type { ReactNode } from "react";
import SidebarSkeleton from "@/shared/components/Layout/SidebarSkeleton";
import { SidebarInset, SidebarProvider } from "@/shared/ui/Sidebar";
import { Skeleton } from "@/shared/ui/Skeleton";

const CARD_SKELETON_KEYS = ["a", "b", "c", "d", "e", "f"] as const;

const ContentCardsSkeleton = () => (
  <div className="flex flex-1 flex-col gap-4">
    <Skeleton className="h-12 w-full" />
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      {CARD_SKELETON_KEYS.map((key) => (
        <Skeleton
          key={key}
          className="h-40"
        />
      ))}
    </div>
  </div>
);

// Mirrors Layout's first-load frame so the swap to the real console is invisible.
// Stays presentational: callers add their own aria semantics around it.
const FakeConsoleSkeleton = ({ children }: { children?: ReactNode }) => (
  <SidebarProvider
    defaultOpen
    className="h-svh max-h-svh"
  >
    <SidebarSkeleton />
    <SidebarInset className="overflow-y-auto px-4 py-2">
      {children ?? <ContentCardsSkeleton />}
    </SidebarInset>
  </SidebarProvider>
);

export default FakeConsoleSkeleton;
